import { render, staticRenderFns } from "./CharityPriceModal.vue?vue&type=template&id=41bb17f4&scoped=true&"
import script from "./CharityPriceModal.vue?vue&type=script&lang=js&"
export * from "./CharityPriceModal.vue?vue&type=script&lang=js&"
import style0 from "./CharityPriceModal.vue?vue&type=style&index=0&id=41bb17f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bb17f4",
  null
  
)

export default component.exports